module.exports = __webpack_public_path__ + "static/img/auma.b4c865ce.png";